module.exports = __webpack_public_path__ + "static/img/diBei-img.f1febe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diBei-img.png
// module id = KEhT
// module chunks = 1